export const BASE = {
  name: 'checkout',
  path: `/checkout`,
};
